import { render, staticRenderFns } from "./inquirebak.vue?vue&type=template&id=51cdc331&scoped=true"
import script from "./inquirebak.vue?vue&type=script&lang=js"
export * from "./inquirebak.vue?vue&type=script&lang=js"
import style0 from "./inquirebak.vue?vue&type=style&index=0&id=51cdc331&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cdc331",
  null
  
)

export default component.exports